import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      props: true,
      component: () => import('../views/home/home.vue'),
      name: 'home',
      scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
      }
    },
    // 栏目列表
    {
      path: '/column/list/:id',
      props: true,
      component: () => import('../views/product/list/list.vue'),
      name: 'column_list'
    },
    // 商品详情
    {
      path: '/product/info/:id',
      props: true,
      component: () => import('../views/product/info/infoList.vue'),
      name: 'product_info'
    },
    // 主推路由
    {
      path: '/main/push/:id',
      props: true,
      component: () => import('../views/mainPush/list.vue'),
      name: 'main_push'
    },
    // 主题系列路由
    {
      path: '/theme/series/:id',
      props: true,
      component: () => import('../views/themeSeries/list/list.vue'),
      name: 'theme_series'
    },
    // 主题系列详情
    {
      path: '/theme/series/detail/:id',
      props: true,
      component: () => import('../views/themeSeries/info/info.vue'),
      name: 'theme_series_detail'
    },
    // 多元碰撞路由
    {
      path: '/multStock/:id',
      props: true,
      component: () => import('../views/multStock/list/list.vue'),
      name: 'multStock'
    },
    // 多元碰撞详情路由
    {
      path: '/multStock/info/:id',
      props: true,
      component: () => import('../views/multStock/info/info.vue'),
      name: 'multStock_info'
    },
    // 蹀愫视频路由
    {
      path: '/TS/video',
      props: true,
      // props: (route) => ({ id: route.query.b }),
      component: () => import('../views/VideoTS/list.vue'),
      name: 'TS_video'
    },
    // 蹀愫视频详情路由
    {
      path: '/TS/video/info/:id',
      props: true,
      component: () => import('../views/VideoTS/info/info.vue'),
      name: 'TS_video_info'
    },
    // 搜索
    {
      path: '/TS/search',
      props: true,
      component: () => import('../views/search/list.vue'),
      name: 'search'
    },
    // 蹀愫World列表
    {
      path: '/TS/world',
      props: true,
      component: () => import('../views/tsWorld/list/list.vue'),
      name: 'tsWorld'
    },
    // 蹀愫World详情
    {
      path: '/TS/world/:id',
      props: true,
      component: () => import('../views/tsWorld/info/info.vue'),
      name: 'TS_world'
    },
    // 店铺列表
    {
      path: '/TS/shop/:id',
      props: true,
      component: () => import('../views/shop/list.vue'),
      name: 'TS_shop'
    },
    // 店铺-查询附近店铺
    {
      path: '/TS/shop/near/:latitude/:longitude',
      props: true,
      component: () => import('../views/shop/nearestShop.vue'),
      name: 'TS_shop_near'
    },
    // 店铺-百度定位
    {
      path: '/baidu/map/:params',
      props: true,
      component: () => import('../views/shop/map_baidu.vue'),
      name: 'bai_du_map'
    },
    // 404
    {
      path: '/*',
      redirect: '/'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js